import Splide from '@splidejs/splide';

export const initSmartDevicesSlider = () => {
  const sliderEl = document.querySelector(
    '[data-pro-multifamily-overview-devices-slider]'
  );

  if (sliderEl) {
    new Splide(sliderEl, {
      type: 'slide',
      focus: 0,
      omitEnd: true,
      perMove: 1,
      fixedWidth: 280,
      speed: 500,
      gap: 20,
      arrows: true,
      pagination: true,
      classes: {
        pagination: 'pro-multifamily-overview-devices__slider-pagination',
        page: 'pro-multifamily-overview-devices__slider-pagination-btn',
      },
    }).mount();
  }
};
